import React from 'react'
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const Box = styled.li`
width: 16rem;
height: 40vh;
background-color: ${props => props.theme.text};
color: ${props => props.theme.body};
padding: 1.5rem 2rem;
margin-right: 8rem;
border-radius: 20px 70px 20px 20px;
display: flex;
flex-direction: column; 
justify-content: space-between;
border: 1px solid ${props => props.theme.body};
transition: all 0.2s ease;

&:hover{
    background-color: ${props => props.theme.body};
    color: ${props => props.theme.text};
    border: 1px solid ${props => props.theme.text};
}
`

const Title = styled.h2`
font-size: calc(1em + 0.5vw);
`

const Description = styled.h2`
font-size: calc(0.8em + 0.5vw);
font-family: 'Karla', sans-serif;
font-weight: 500;
`
const Tags = styled.div`
border-top: 2px solid ${props => props.theme.body};
padding-top: 0.5rem;
display:flex;
flex-direction: wrap;
${Box}:hover &{
    border-top: 2px solid ${props => props.theme.text};
}
`
const Tag = styled.span`
margin-rightL: 1rem;
font-size:calc(0.8rem + 0.3vw);

`

const Footer = styled.footer`
display: flex;
justify-content: space-between;
`

const Link = styled(NavLink)`
background-color:${props => props.theme.body};
color:${props => props.theme.text};
text-decoration: none;
padding:0.5rem calc(2rem +2vw);
font-size: calc(1em + 0.5vw);
${Box}:hover &{
    border-top: 2px solid ${props => props.theme.text};
    color:${props => props.theme.body};
}
`
const WorkCard = (props) => {
    const {id,name,description,tags,demo,github} = props.data;
  return (
    <Box key={id}>
        <Title>{name}</Title>
        <Description>
            {description}
        </Description>
        <Tags>
            {
                tags.map((t,id) => {
                    return <Tag key={id}>#{t}</Tag>
                  })
            }
        </Tags>
        <Footer>
            <Link to={{pathname: `${demo}`}}  target="_blank">
                Visit
            </Link>
        </Footer>
    </Box>
  )
}

export default WorkCard